import { render, staticRenderFns } from "./saleOrderCopacking.vue?vue&type=template&id=3c3d232c"
import script from "./saleOrderCopacking.vue?vue&type=script&lang=js"
export * from "./saleOrderCopacking.vue?vue&type=script&lang=js"
import style0 from "./saleOrderCopacking.vue?vue&type=style&index=0&id=3c3d232c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports